import { ComponentRegistry } from '../core/component-registry';
import { MarketplaceListComponent } from './marketplace-list/marketplace-list.component';
import { AcceptDemandComponent } from './accept-demand/accept-demand.component';
import { AcceptServiceComponent } from './accept-service/accept-service.component';
import { ColumnMarketplaceDemandComponent } from './column-marketplace-demand/column-marketplace-demand.component';
import { ColumnMarketplaceServiceComponent } from './column-marketplace-service/column-marketplace-service.component';
import { WithdrawAssignmentComponent } from './withdraw-assignment/withdraw-assignment.component';
import { WithdrawAttendantComponent } from './withdraw-attendant/withdraw-attendant.component';
var MarketplaceModule = /** @class */ (function () {
    /**
     * Creates an instance of MarketplaceModule.
     */
    function MarketplaceModule() {
        ComponentRegistry.register('list', 'MarketplaceListComponent', MarketplaceListComponent);
        ComponentRegistry.register('overlay', 'AcceptDemandComponent', AcceptDemandComponent);
        ComponentRegistry.register('overlay', 'AcceptServiceComponent', AcceptServiceComponent);
        ComponentRegistry.register('overlay', 'WithdrawAssignmentComponent', WithdrawAssignmentComponent);
        ComponentRegistry.register('overlay', 'WithdrawAttendantComponent', WithdrawAttendantComponent);
        ColumnMarketplaceDemandComponent.register();
        ColumnMarketplaceServiceComponent.register();
    }
    return MarketplaceModule;
}());
export { MarketplaceModule };
